import { parseNumber } from './numberConversions'

export const annuity = (pv, n, r = 0.06) => {
  const _pv = parseNumber(pv)
  const fv = _pv * Math.pow((1 + r), n)
  return fv
}

export const growthFromRiskRating = (pv, n, riskRating) => {
  const _pv = parseNumber(pv)
  const _riskRating = parseNumber(riskRating)
  const _n = parseNumber(n)

  const r = _riskRating / 100

  const fv = _pv * Math.pow((1 + r), _n)
  const growth = fv - _pv

  return growth
}
